export default __webpack_public_path__ + "static/github-362b59a2ad928f806b4f4b426ddeaae7.png";